import React, {forwardRef} from "react"
import {FieldFormElementViewProps} from "../../../render/form-elemnent-view";
import FieldPopover_FormComponent from "../components/form/form-component";

// const debug = "FieldPopover_FormElementView"
const debug = false

const FieldPopover_FormElementView = forwardRef(function (props: FieldFormElementViewProps, ref: any) {
    const value = props.field.getViewValue(props.model)

    debug && console.log(debug, 'render', value, props.model, props.field)

    return (
        <FieldPopover_FormComponent
            ref         = {ref}
            className   = {props.className}
            field       = {props.field}
            size        = {props.size}
            value       = {value}
            model       = {props.model}
            disabled    = {props.disabled}
            options     = {props.options}
            onChange    = {props.onChange}
        />
    )

})

export default FieldPopover_FormElementView